module.exports = __webpack_public_path__ + "static/media/crosshairs.80b10d7a.svg";